"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticVisitor = void 0;
const sheet_db_1 = require("../../../../sheet_db");
const antlr_files_1 = require("../../../antlr_files");
const visitor_base_1 = require("../visitor.base");
const formula_validator_1 = require("./formula.validator");
const PLAN_VARIABLES = new Set(['start_date', 'end_date', 'payout_date']);
class SemanticVisitor extends visitor_base_1.VisitorBase {
    _semanticErrors;
    visitedTabs = new Map();
    constructor() {
        super();
        this._semanticErrors = [];
    }
    get semanticErrors() {
        return this._semanticErrors;
    }
    visitColumn(node) {
        const varName = node.abstractText?.split('.')[1] ?? '';
        if (node.isPlanVariable()) {
            if (!PLAN_VARIABLES.has(varName))
                this._semanticErrors.push({
                    message: `Invalid plan variable name <${varName}>. accepted values: [${[
                        ...PLAN_VARIABLES,
                    ].join(', ')}]`,
                    from: node.startPosition ?? 0,
                    to: node.endPosition ?? 1,
                    severity: 'error',
                    error_code: sheet_db_1.SemanticErrorCodes.TOKEN_NOT_INDENTIFIED,
                    token: node.token,
                    error_type: 'semantic',
                });
            return;
        }
        const colDef = node.column;
        if (!colDef) {
            this._semanticErrors.push({
                message: `Column ${node.text} does not exist`,
                from: node.startPosition ?? 0,
                to: node.endPosition ?? 1,
                severity: 'error',
                error_code: sheet_db_1.SemanticErrorCodes.TOKEN_NOT_INDENTIFIED,
                token: node.token,
                error_type: 'semantic',
            });
            return;
        }
        return;
    }
    visitConstant(node) {
        // TODO: remove once percentage use gets implemented/tested
        if (node.terminalType === antlr_files_1.Parser.PERCENTAGE)
            this._semanticErrors.push({
                message: `Direct use of percentage not implemented yet`,
                from: node.startPosition ?? 0,
                to: node.endPosition ?? 1,
                severity: 'error',
                error_code: sheet_db_1.SemanticErrorCodes.INVALID_DATA_TYPE,
                token: node.token,
                error_type: 'semantic',
            });
    }
    visitFormula(node) {
        const formulaValidator = new formula_validator_1.FormulaValidator(node);
        const formulaDef = node.formulaDef;
        formulaValidator.validateExistentFormula();
        // stop validations if formula does not exist
        if (formulaValidator.semanticErrors.length > 0 || !formulaDef) {
            this._semanticErrors.push(...formulaValidator.semanticErrors);
            return;
        }
        formulaValidator.validateRequiredArgsCount();
        // window functions cannot be nested
        if ((0, sheet_db_1.isWindowFunctionCheck)(formulaDef)) {
            formulaValidator.validateWindowFunction();
            this._semanticErrors.push(...formulaValidator.semanticErrors);
            return;
        }
        formulaValidator.validateArgs();
        this._semanticErrors.push(...formulaValidator.semanticErrors);
    }
    visitForeign(node) {
        if (!node.tab) {
            this._semanticErrors.push({
                message: `Tab '${node.tabToken}' does not exist`,
                from: node.startPosition ?? 0,
                to: node.endPosition ?? 1,
                severity: 'error',
                error_code: sheet_db_1.SemanticErrorCodes.TOKEN_NOT_INDENTIFIED,
                token: node.token,
                error_type: 'semantic',
            });
            return;
        }
        if (!node.column) {
            this._semanticErrors.push({
                message: `Column '${node.columnToken}' does not exist on tab '${node.tabToken}'`,
                from: node.startPosition ?? 0,
                to: node.endPosition ?? 1,
                severity: 'error',
                error_code: sheet_db_1.SemanticErrorCodes.TOKEN_NOT_INDENTIFIED,
                token: node.token,
                error_type: 'semantic',
            });
            return;
        }
        this.visitedTabs.set(node.tab.id, node.tab);
        if (this.visitedTabs.size > 1) {
            const message = `Many tabs referenced: [${[...this.visitedTabs]
                .map(([_, tab]) => tab.name)
                .join(', ')}]`;
            const multipleTabsError = this._semanticErrors.find(err => err.error_code === sheet_db_1.SemanticErrorCodes.FOREIGN_REFERENCE_MULTIPLES_TABS);
            if (multipleTabsError) {
                multipleTabsError.message = message;
                return;
            }
            this._semanticErrors.push({
                from: node.startPosition ?? 0,
                to: node.endPosition ?? 1,
                message,
                severity: 'error',
                error_code: sheet_db_1.SemanticErrorCodes.FOREIGN_REFERENCE_MULTIPLES_TABS,
                token: node.token,
                error_type: 'semantic',
            });
        }
    }
}
exports.SemanticVisitor = SemanticVisitor;
